import React, { Component } from 'react';
import { connect } from 'react-redux';

/* for route */
import { browserHistory } from 'react-router';
import { routes } from '../../../redux/api/routes.js';
let { s3BrochureUrl } = routes;

/* Actions */
import { updateBinderParameter } from '../../../redux/actions';

class BinderStep1 extends Component {

	constructor(props) {
        super(props);
        this.state = {
			error: {
				specPageSetsError: '',
				printZipCodeError: '',
				printPhoneNumberError: '',
				emailAddressError: '',
				inValidEmailAddressError: ''
			}
        }
    }

	componentWillMount() {
		window.scrollTo(0, 0);
		if(this.props.state.brochure.selectedItems.length === 0) {
			//Redirect to list page if user directly comes on this page
			browserHistory.push("/list");
		}
	}

	validateEmail(email) {
      var re = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
      return re.test(email);
    }

	handleBinderParamsChange(paramName, event) {
		let { state } = this.props,
			 self = this;
		var paramValue = event.target.value,
			type = event.target.type;

		if(type === "checkbox") {
			paramValue = event.target.checked?"Y":"N";

			//Check if brochure number is checked or not. If checked then update brochureName or remove brochure name
			if(paramName === "hasBrochureName") {
				self.props.updateBinderParameter({
					name: "brochureName",
					value: paramValue === "Y"?state.brochure.payload.brochure.brochureName:""
				})
			}
			//If divider of pages checkbox changes
			if(paramName === "hasDividerPages") {
				//Set dividerPageSets to no of page length if checked else 0
					self.props.updateBinderParameter({
					name: "dividerPageSets",
					value: paramValue === "Y"?state.brochure.payload.brochure.pages.length:0
				})
				//Set dividerPageSets to no of page length if checked else 0
					self.props.updateBinderParameter({
					name: "dividerPageName",
					value: paramValue === "Y"?state.brochure.payload.brochure.pages.map((item)=>{return item.pageTitle}):[]
				})
			}
			//Check if download binder check box is selected
			if(paramName === "hasDownloadBinder") {
				//Set email addresses if download binder is checked or unchecked
					self.props.updateBinderParameter({
					name: "emailAddress",
					value: paramValue === "Y"?state.brochure.payload.binders[state.brochure.payload.binders.length-1].emailAddress:""
				})
			}
		}

		this.setState({
			error: {...this.state.error,
				specPageSetsError: paramName === "specPageSets"?'':this.state.error.specPageSetsError
			}
		})

    	self.props.updateBinderParameter({
			name: paramName,
			value: paramValue
		})
    }

	handleContinue(event) {
		event.preventDefault();
		let { state } = this.props;
		let binders = state.brochure.payload.binders[state.brochure.payload.binders.length-1];

		this.setState({
			error: {...this.state.error,
				specPageSetsError: '',
				emailAddressError: ''
			}
		})

		var errorOccurred = false;
		if((binders.hasSpecPages === "Y" && binders.specPageSets === "") ||
			binders.emailAddress === "" ||
			this.state.error.printZipCodeError === "error" ||
			this.state.error.printPhoneNumberError === "error"
		) {
			errorOccurred = true;
		}

		//Validate Email addresses
		var self = this,
			inValidEmails = [];
		if(binders.emailAddress !== "") {
			var emailAddresses = binders.emailAddress.split(",");
			for(var i=0;i<emailAddresses.length;i++) {
				emailAddresses[i] = emailAddresses[i].trim();
				if(emailAddresses[i] !=="" && !self.validateEmail(emailAddresses[i])) {
					errorOccurred = true;
					inValidEmails.push(emailAddresses[i]);
				}
			}
		}

		this.setState({
			error: {...this.state.error,
				specPageSetsError: (binders.hasSpecPages === "Y" && binders.specPageSets === "")?'error':'',
				emailAddressError: binders.emailAddress === ""?"error":"",
				inValidEmailAddressError: inValidEmails.length === 0?"":inValidEmails.join(", "),
			}
		})

		if(!errorOccurred) {
			browserHistory.push("/create-binder-step2");
		}
	}

  	render() {
		let { state } = this.props;
		let { brochure } = state.brochure.payload;
		let binders = state.brochure.payload.binders.length > 0?state.brochure.payload.binders[state.brochure.payload.binders.length-1]:[];
	  	return (
	      	<div>
	        	<div className="push"><h1>Order Binder</h1></div>
		        <div className="push">
					<h2 className="pageTitle">Input Binder Information</h2>
					<hr />
					<p className="importantText bold">Note: Binders will NOT include any pricing input during the create brochure process.</p>
		        </div>
	        	<form className="inputBinderInformationForm" name="inputBinderInformationForm" id="inputBinderInformationForm" onSubmit={this.handleContinue.bind(this)}>
	          		<div className="push">
	            		<h3>Include the following in this binder:</h3>
						<div className="indented">
							<table className="inputBinderInformationCheckboxTable">
								<tbody>
									{brochure.brochureName !== ""
										?<tr>
											<td>
												<input type="checkbox" name="whatToIncludeInBinder" defaultChecked={binders.hasBrochureName && binders.hasBrochureName === "Y"?true:false} id="whatToIncludeInBinder_brochureName" onClick={this.handleBinderParamsChange.bind(this, "hasBrochureName")} />
											</td>
											<td>
												<label htmlFor="whatToIncludeInBinder_brochureName"><strong>Brochure Name:</strong></label> &nbsp; {brochure.brochureName}<br /><i>(Project Name)</i>
											</td>
										</tr>
										:null
									}
									{brochure.customerLogo !== ""
										?<tr>
											<td>
												<input type="checkbox" name="whatToIncludeInBinder" defaultChecked={binders.hasCustomerLogo && binders.hasCustomerLogo === "Y"?true:false} id="whatToIncludeInBinder_customerLogo" onClick={this.handleBinderParamsChange.bind(this, "hasCustomerLogo")} />
											</td>
											<td>
												<label htmlFor="whatToIncludeInBinder_customerLogo"><strong>Customer Logo</strong></label><i>(Maximum 500KB)</i> &nbsp; {brochure.customerLogo?<span className="bold">Selected Logo: <a href={s3BrochureUrl+brochure.customerLogo} target="_blank">{brochure.customerLogo}</a></span>:null}
											</td>
										</tr>
										:null
									}
									{brochure.hasCoverPage === "Y"
										?<tr>
											<td>
												<input type="checkbox" name="whatToIncludeInBinder" defaultChecked={binders.hasCoverPage && binders.hasCoverPage === "Y"?true:false} id="whatToIncludeInBinder_coverPage" onClick={this.handleBinderParamsChange.bind(this, "hasCoverPage")} />
											</td>
											<td>
												<label htmlFor="whatToIncludeInBinder_coverPage"><strong>Cover Page</strong></label>
											</td>
										</tr>
										:null
									}
									<tr>
										<td>
											<input type="checkbox" name="whatToIncludeInBinder" defaultChecked={binders.hasDividerPages && binders.hasDividerPages === "Y"?true:false} id="whatToIncludeInBinder_dividerPages" onClick={this.handleBinderParamsChange.bind(this, "hasDividerPages")} />
										</td>
										<td>
											<label htmlFor="whatToIncludeInBinder_dividerPages"><strong>Divider Pages</strong></label> <i>(Page titles will be used as divider pages.)</i>
											<div className="indented">
												{brochure.pages.map((item, index) => {
													return <p key={index}><strong>Page {item.pageNumber}:</strong> {item.pageTitle}</p>
												})}
											</div>
										</td>
									</tr>
									{brochure.productInfo.hasProductSpec === "Y"
										?<tr>
											<td>
												<input type="checkbox" name="whatToIncludeInBinder" defaultChecked={binders.hasSpecPages && binders.hasSpecPages === "Y"?true:false} id="whatToIncludeInBinder_specPages" onClick={this.handleBinderParamsChange.bind(this, "hasSpecPages")} />
											</td>
											<td>
												<label htmlFor="whatToIncludeInBinder_specPages"><strong>Spec Pages:</strong></label>
												&nbsp;
												<label>Number of Sets: <input type="text" className={this.state.error.specPageSetsError} name="numberOfSets" onKeyPress={this.props.acceptNumbersOnly} defaultValue={binders.specPageSets} onChange={this.handleBinderParamsChange.bind(this, "specPageSets")} size={5} /></label>
											</td>
										</tr>
										:null
									}
									{brochure.productInfo.hasWarrantyInfo === "Y"
										?<tr>
											<td>
												<input type="checkbox" name="whatToIncludeInBinder" defaultChecked={binders.hasWarrantyInfoPages && binders.hasWarrantyInfoPages === "Y"?true:false} id="whatToIncludeInBinder_warrantyInformationPages" onClick={this.handleBinderParamsChange.bind(this, "hasWarrantyInfoPages")} />
											</td>
											<td>
												<label htmlFor="whatToIncludeInBinder_warrantyInformationPages"><strong>Warranty Information Pages</strong></label>
											</td>
										</tr>
										:null
									}
									<tr>
										<td>
											<input type="checkbox" name="whatToIncludeInBinder" defaultChecked={binders.hasMortgageCalcSheet && binders.hasMortgageCalcSheet === "Y"?true:false} id="whatToIncludeInBinder_mortageCalculationSpreadsheet" onClick={this.handleBinderParamsChange.bind(this, "hasMortgageCalcSheet")} />
										</td>
										<td>
											<label htmlFor="whatToIncludeInBinder_mortageCalculationSpreadsheet"><strong>Mortgage Calculation Spreadsheet</strong></label>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
	          		</div>
	          		<div className="push">
	            		<h3>Enter your email to receive this binder</h3>
	            		<div className="indented">
							<table className="inputBinderInformationCheckboxTable">
								<tbody>
									<tr>
										<td>
											<table className="formTableTypeA">
												<tbody>
													{this.state.error.inValidEmailAddressError !== ""
														?<tr><td></td><td className="bold red">Please enter valid email address{this.state.error.inValidEmailAddressError.split(",").length > 1 ?"es":""}.<br/>{this.state.error.inValidEmailAddressError}</td></tr>
														:null
													}
													<tr>
														<td>
															<label htmlFor="textarea_emailAddresses"><strong>Email Addresses</strong></label><br />
															<i className="unbold">(Use commas to separate addresses.)</i>
														</td>
														<td className="containingTextArea">
															<textarea rows={6} cols={40} className={this.state.error.emailAddressError} defaultValue={binders.emailAddress} onBlur={this.handleBinderParamsChange.bind(this, "emailAddress")} id="textarea_emailAddresses" />
														</td>
													</tr>
												</tbody>
											</table>
										</td>
									</tr>
								</tbody>
							</table>
	            		</div>
	          		</div>
		        	<p className="textRight"><input type="submit" value="Continue" /></p>
	        	</form>	{/* / .inputBinderInformationForm#inputBinderInformationForm */}
      		</div>
    	);
  	}
};
const mapStateToProps = (state) => {
	return { state };
};

const mapDispatchToProps = (dispatch) => ({
	updateBinderParameter: (queryStringParams) => dispatch(updateBinderParameter(queryStringParams))
});

BinderStep1 = connect(mapStateToProps, mapDispatchToProps)(BinderStep1);
export default BinderStep1;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Binders/step1.js